export const DEV_MODE = process.env.REACT_APP_DEV_MODE;
export const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN;
